<template>
  <div id="app">
    <DailyForecastComponent  />
  </div>
</template>

<script>
import DailyForecastComponent from "./DailyForecastComponent.vue";

export default {
  name: 'app',
  components: {
    DailyForecastComponent,
  }
}
</script>
